import { useTranslation } from "react-i18next";

import {
  useCreateInformationSystemMutation,
  useEditInformationSystemMutation,
} from "~/schemas/generated/graphql";
import { useNotify } from "~/shared/hooks/useNotify";

export const infoSystemQueryManagement = ({ refetch, closeModal }) => {
  const { notifySuccess, notifyError } = useNotify();
  const { t } = useTranslation();

  const [editInfoSystem] = useEditInformationSystemMutation({
    onCompleted() {
      refetch();
      closeModal();
      notifySuccess(t("common.сhange_was_successful"));
    },
    onError(vals) {
      notifyError(vals["message"]);
    },
  });

  const [addInfoSystem] = useCreateInformationSystemMutation({
    onCompleted() {
      refetch();
      closeModal();
      notifySuccess(t("common.сhange_was_successful"));
    },
    onError(vals) {
      notifyError(vals["message"]);
    },
  });

  return { editInfoSystem, addInfoSystem };
};
